// extracted by mini-css-extract-plugin
export default {"newsletter":"VQi9pDLzXBOwjBxNverg"};